"use client";
import React, { MouseEventHandler } from "react";
import { useRouter } from "next/compat/router";

interface LinkNoPrefetchProps {
  href: string;
  as?: string;
  children: React.ReactNode;
  className?: string;
  shallow?: boolean;
  scroll?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const LinkNoPrefetch = React.forwardRef<
  HTMLAnchorElement,
  LinkNoPrefetchProps
>(
  (
    {
      href,
      as,
      children,
      className,
      shallow = false,
      scroll = true,
      onClick,
      ...props
    },
    ref,
  ) => {
    const router = useRouter();

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
      // Allow default behavior for middle click, cmd/ctrl+click (new tab)
      if (
        event.defaultPrevented ||
        event.button !== 0 || // Left-click only
        event.metaKey || // Cmd (Mac)
        event.ctrlKey || // Ctrl (Windows/Linux)
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      event.preventDefault();
      onClick?.(event);

      //todo: not working
      router?.push(href, as, { shallow, scroll });
    };

    return (
      // eslint-disable-next-line react/forbid-elements
      <a
        ref={ref}
        href={as ?? href}
        onClick={handleClick}
        className={className}
        {...props}
      >
        {children}
      </a>
    );
  },
);

LinkNoPrefetch.displayName = "LinkNoPrefetch";
